import { Component, EventEmitter, Input, Output } from '@angular/core';

const DEFAULT_COLORS = [
  '#4E8BAD',
  '#9EABC6',
  '#41B5BA',
  '#41BA88',
  '#317A6D',
  '#418FBA',
  '#548A99',
  '#4169BA',
  '#5349A3',
  '#25165E',
];

@Component({
  selector: 'dashboard-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss'],
})
export class ColorPickerComponent {
  @Input() color: string;
  @Output() colorChange: EventEmitter<string> = new EventEmitter<string>();

  show = false;
  defaultColors: string[] = DEFAULT_COLORS;

  constructor() {}

  changeColor(color: string): void {
    this.color = color;
    this.colorChange.emit(this.color);
    this.show = false;
  }

  toggleColors(): void {
    this.show = !this.show;
  }
}
